// After the EHR connect round-trip, the public /callback 303s the browser back
// to /?ehr=<result> (SPEC-ADDENDUM §A5b). This reads that query param on load,
// shows a toast, and strips the param so a refresh doesn't re-toast.

import { useEffect } from "react";

import { pushToast, type ToastKind } from "../components/Toast";

const MESSAGES: Record<string, [ToastKind, string]> = {
  connected: ["success", "Medical records connected — pulling available records now."],
  denied: ["info", "Connection canceled — consent wasn't granted."],
  invalid: ["error", "That connection link expired or was already used. Please try connecting again."],
  error: ["error", "Something went wrong connecting your records. Please try again."],
  disabled: ["info", "Records connect isn't enabled in this environment."],
};

export function useEhrRedirectToast(): void {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const result = params.get("ehr");
    if (!result) return;
    const [kind, message] = MESSAGES[result] ?? (["info", `Records: ${result}`] as [ToastKind, string]);
    pushToast(kind, message);
    // Strip our params so refresh/back doesn't replay the toast.
    params.delete("ehr");
    params.delete("subject_id");
    const qs = params.toString();
    window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : ""));
  }, []);
}
